/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Meeting_Guest_Forbidden_TitleInputs */

const vi_meeting_guest_forbidden_title = /** @type {(inputs: Meeting_Guest_Forbidden_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bạn không có quyền xem danh bạ khách mời`)
};

/**

* @param {Meeting_Guest_Forbidden_TitleInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const meeting_guest_forbidden_title = /** @type {((inputs?: Meeting_Guest_Forbidden_TitleInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Meeting_Guest_Forbidden_TitleInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_meeting_guest_forbidden_title(inputs)
});